import React, { useEffect } from "react";
import { connect } from "react-redux";
import { Table  } from 'antd';
import Card from "components/card";
import Button from "components/button";
import CrudOption from "components/dropdown/crudoption";
import { PlusOutlined } from '@ant-design/icons';
import { getModuleList, doModuleDelete } from "../../../../redux/module/moduleState";
import SearchFilter from "components/search/SearchFilter";
import { getYesNoValue, handleTableChange } from "../../../../utils/index";

const ModuleTable = ({ recordList, pagination, doSearch, filters, doDelete, user, ...props }) => {
	console.log(user);
  	const columns = [
		{
	        title: `Module Name`,
	        dataIndex: 'mod_name',
	        key: 'mod_name',
	        width: '20%',
	        render:(mod_name) => <span>{mod_name}</span> 
	    },
		{
	        title: `Route`,
	        dataIndex: 'mod_route',
	        key: 'mod_route',
	        width: '20%',
	        render:(mod_route) => <span>{mod_route}</span> 
	    },
		{
	        title: `Level`,
	        dataIndex: 'mod_level',
	        key: 'mod_level',
	        width: '8%',
	        render:(mod_level) => <span>{mod_level}</span> 
	    },
		{
	        title: `Parent Module`,
	        dataIndex: 'mod_route',
	        key: 'mod_route',
	        width: '20%',
	        render:(mod_route) => <span>{mod_route}</span> 
	    },	
		{
	        title: `Is Menu`,
	        dataIndex: 'mod_asmenu',
	        key: 'mod_asmenu',
	        width: '10%',
	        render:(mod_asmenu) => <span>{getYesNoValue(mod_asmenu)}</span> 
	    },	 
		{
	        title: `Is Active`,
	        dataIndex: 'mod_isactive',
	        key: 'mod_isactive',
	        width: '10%',
	        render:(mod_isactive) => <span>{getYesNoValue(mod_isactive)}</span> 
	    },   
	    {
	        title: <Button extra="btn-small">
			      		<a href={`/console/modules/add`}>
					        <PlusOutlined />{' '}Add
					  	</a>
			    	</Button>,
	        dataIndex: 'mod_id',
	        key: 'mod_id',
	        width: '12%',
	        render:(mod_id) => <CrudOption baseRoute="/console/modules" recordId={mod_id} deleteHandler={doDelete}/>
	    },
    ];

	useEffect(() => {
		doSearch({paginate: pagination.per_page});
	}, [doSearch, pagination.per_page]);
	
  	return (
	    <Card extra={"w-full h-full p-4"}>
	      	<div className="h-full overflow-x-scroll xl:overflow-x-hidden">
	      	
				<SearchFilter searchHandler={doSearch} filters={filters} pagination={pagination}/>

	      		<Table
		        	dataSource={recordList} 
		        	columns={columns} 
		            rowKey={(record) => record.mod_id}
		        	pagination={pagination}    
		            onChange={handleTableChange(doSearch, filters)}                 	
	        	/>
	      	</div>
	    </Card>
  );
};

const mapStateToProps = (state) => ({
	recordList: state.module.moduleList?.items,
  	pagination: state.module.moduleList?.pagination,
	filters: state.module.moduleList?.filters,
  	requesting: state.module.moduleList?.requesting,
  	error: state.module.moduleList?.error,
	user: state.auth.user,
});

const mapDispatchToProps = (dispatch) => ({
	doSearch: (filters) => dispatch(getModuleList(filters)),
  	doDelete: (id) => dispatch(doModuleDelete(id)),
});

export default connect(mapStateToProps, mapDispatchToProps)(ModuleTable);
